import React from 'react';
import { colors } from '../../theme/tokens/colors';
import { typography } from '../../theme/tokens/typography';

export interface CalendarDateIconProps {
  /**
   * Day of the month (1-31)
   */
  day: number;
  /**
   * Size of the icon in pixels (default: 36)
   */
  size?: number;
  /**
   * Optional className for custom styling
   */
  className?: string;
}

/**
 * CalendarDateIcon - A calendar icon with the day number displayed
 * 
 * Shows a calendar icon with a red header bar and the day number
 * displayed in the white area below.
 */
export const CalendarDateIcon: React.FC<CalendarDateIconProps> = ({
  day,
  size = 36,
  className,
}) => {
  // Calculate font size proportionally to icon size
  const fontSize = (size / 36) * typography.fontSizeHeading4;
  const lineHeight = (size / 36) * typography.lineHeightHeading4;

  return (
    <div
      className={className}
      style={{
        position: 'absolute',
        width: size,
        height: size,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Calendar SVG */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: 'absolute', top: 0, left: 0 }}
      >
        <path
          d="M28 2C31.3137 2 34 4.68629 34 8V28C34 31.3137 31.3137 34 28 34H8C4.68629 34 2 31.3137 2 28V8C2 4.68629 4.68629 2 8 2H28Z"
          fill={colors.white}
          stroke={colors.black}
          strokeWidth="4"
        />
        <path
          d="M4 8C4 5.79086 5.79086 4 8 4H28C30.2091 4 32 5.79086 32 8V12H4V8Z"
          fill={colors.accentRed}
        />
      </svg>

      {/* Day number overlay */}
      <span
        style={{
          position: 'relative',
          marginTop: size * 0.22, // Position below the red header
          fontSize: `${fontSize}px`,
          lineHeight: `${lineHeight}px`,
          fontWeight: 600,
          color: colors.black,
          zIndex: 1,
        }}
      >
        {day}
      </span>
    </div>
  );
};

export default CalendarDateIcon;
